import $ from 'jquery';
import InView from 'inview';

const initPageNav = () => {
	const pageNav = document.querySelectorAll('.em-page-navigation');

	pageNav.forEach((nav) => {
		const navContainer = nav.querySelector('.em-page-navigation__nav');
		const label = nav.querySelector('.em-page-navigation__mobile-label');
		const navLinks = nav.querySelectorAll('a');

		label.onclick = () => {
			$(label).toggleClass('active');
			$(navContainer).slideToggle();
		};

		navContainer.onclick = () => {
			const mql = window.matchMedia('(max-width: 1141px)');
			if (mql.matches) {
				$(label).toggleClass('active');
				$(navContainer).slideToggle();
			}
		};

		navLinks.forEach((link) => {
			InView(document.querySelector(link.hash), (isInView, data) => {
				if (isInView && data.elementOffsetTopInViewHeight < data.inViewHeight / 2) {
					navLinks.forEach((link) => {
						link.classList.remove('active');
					});
					link.classList.add('active');
				}
			});
		});
	});
};

document.addEventListener('DOMContentLoaded', initPageNav);
